import { atom } from 'recoil'
import { keyFactory } from 'src/utils/recoil'
import { DevicesSizes } from 'src/components/theme/breakpoints'

const settingKey = keyFactory('configuration')

export const device = atom<DevicesSizes>({
  key: settingKey('device-type'),
  default: undefined,
})
